"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arbus": {
    "2d9033da": [{
      "hkey": "8bfc3232",
      "slug": "ingurtosu-pitzinurri",
      "name": "Ingurtosu-Pitzinurri",
      "primary": true,
      "skipSearch": false
    }],
    "pitzinurri": [{
      "hkey": "8bfc3232",
      "slug": "ingurtosu-pitzinurri",
      "name": "Ingurtosu-Pitzinurri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "910fc163": [{
      "hkey": "e453474c",
      "slug": "torre-dei-corsari",
      "name": "Torre dei Corsari",
      "primary": true,
      "skipSearch": false
    }],
    "torre-di-flumentorgiu": [{
      "hkey": "e453474c",
      "slug": "torre-dei-corsari",
      "name": "Torre dei Corsari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b1357ae4": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "skipSearch": false
    }],
    "bidderdi": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e7fc722": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "skipSearch": false
    }],
    "gennamari": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba077af0": [{
      "hkey": "9b6ef479",
      "slug": "marina-di-gutturu-flumini",
      "name": "Marina di Gutturu Flumini",
      "primary": true,
      "skipSearch": false
    }],
    "guttur-e-flumini": [{
      "hkey": "9b6ef479",
      "slug": "marina-di-gutturu-flumini",
      "name": "Marina di Gutturu Flumini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "02b00393": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "skipSearch": false
    }],
    "naracauli": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa3f3e78": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "skipSearch": false
    }],
    "righi": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31272f93": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "skipSearch": false
    }],
    "telle": [{
      "hkey": "727e0efb",
      "slug": "arbus",
      "name": "Arbus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;